<template>
  <form name="form">
    <b-modal id="ChangeCertificate" hide-footer size="xl">
      <template #modal-title> Edycja certyfikatu </template>

      <div class="row">
        <div class="col">
          <label for="certificateName" class="form-label"
            >Nazwa Certyfikatu</label
          >
          <input
            type="text"
            class="form-control"
            id="certificateName"
            v-model="certificate.name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="validFrom" class="form-label">Certyfikat ważny od</label>
          <b-form-datepicker
            id="validFrom"
            v-model="certificate.validFrom"
            class="mb-2"
          ></b-form-datepicker>
        </div>
        <div class="col">
          <label for="validTo" class="form-label">Certyfikat ważny do</label>
          <b-form-datepicker
            id="validTo"
            v-model="certificate.validTo"
            class="mb-2"
          ></b-form-datepicker>
        </div>
      </div>

      <div class="col align-self-end div-form-buttons-area">
        <button class="btn btn-primary" type="button" @click="SaveData">
          Zapisz
        </button>
        <button
          class="btn btn-warning"
          type="button"
          @click="ClearFormAndCloseWindow"
        >
          Zamknij
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../../mixins/url";

export default {
  components: {},
  mixins: [urlConfig],
  props: ["certificate"],
  data() {
    return {
      form: {
        id: 0,
        name: "",
        validFrom: undefined,
        validTo: undefined,
      },
      formErrors: [],
    };
  },
  methods: {
    ClearFormAndCloseWindow() {
      this.$bvModal.hide("ChangeCertificate");
      this.form = {
        id: 0,
        name: "",
        validFrom: undefined,
        validTo: undefined,
      };
      this.formErrors = [];
    },
    SaveData() {
      this.formErrors = [];
      this.form.id = this.certificate.id;
      this.form.name = this.certificate.name;
      this.form.validFrom = this.certificate.validFrom;
      this.form.validTo = this.certificate.validTo;

      this.ValidateForm();
      if (this.formErrors.length == 0) {
        var url = this.url.serverUrl + this.url.Producer.EditCertificate;
        var that = this;
        axios
          .post(url, this.form)
          .then(function (res) {
            that.form.id = res.data;
            that.$emit("CertificateWasEdited", that.form);
            that.ClearFormAndCloseWindow();
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },
    ValidateForm() {
      if (!this.form.name) {
        this.formErrors.push("certificateNameError");
      }
      if (!this.form.validFrom) {
        this.formErrors.push("validFromError");
      }
      if (!this.form.validTo) {
        this.formErrors.push("validToError");
      }
    },
  },
};
</script>